import { useQuery } from '@tanstack/react-query';

import OffersService from '~/services/OffersService';

import { offerQueryKeys } from './useGetOffer';

export type CampaignScheduleSourceRecord = {
  id: string;
  synced_at?: string | null;
  opportunity__c?: string | null;
  brand__c?: string | null;
  market__c?: string | null;
  dynamic_campaign_type__c?: string | null;
  start_offline__c?: string | null;
  end_offline__c?: string | null;
  start_online__c?: string | null;
  end_online__c?: string | null;
  schedule_start_time__c?: string | null;
  schedule_end_time__c?: string | null;
};

export function useGetSalesforceCampaignSchedules(
  offerId: string | undefined,
  { enabled = true }: { enabled?: boolean } = {},
) {
  return useQuery({
    queryKey: offerQueryKeys.salesforceCampaignSchedules(offerId),
    queryFn: async () => {
      if (!offerId) {
        throw new Error('offerId is required');
      }

      const response = await OffersService.getSalesforceCampaignSchedules(offerId);
      return response.result as Array<CampaignScheduleSourceRecord>;
    },
    enabled: enabled && !!offerId,
  });
}
